import { AccreditationFlowEnumType } from '__generated__/graphql';
import { FC } from 'react';

import AccreditationResumeCard from './AccreditationResumeCard';

type ResumableEntity = {
  id: string;
  name: string;
  investorApplication?: { accreditationFlow?: AccreditationFlowEnumType | null } | null;
};

/**
 * Every entity routed into the in-app CVL flow, listed independently of which
 * entity is currently selected below
 */
const AccreditationResumeSection: FC<{ investmentEntities: ResumableEntity[] }> = ({
  investmentEntities,
}) => {
  const entitiesOnCvlFlow = investmentEntities.filter(
    investmentEntity =>
      investmentEntity.investorApplication?.accreditationFlow ===
      AccreditationFlowEnumType.CvlOnline
  );

  if (!entitiesOnCvlFlow.length) return null;

  return (
    <section aria-labelledby="accreditation-applications-heading" className="mb-10">
      <h2 id="accreditation-applications-heading" className="mb-1 font-bold text-gray-900">
        Your accreditation applications
      </h2>
      <p className="mb-4 text-sm text-gray-600">
        {entitiesOnCvlFlow.length === 1
          ? 'Pick up your application where you left off.'
          : 'Pick up any of your applications where you left off.'}
      </p>
      <div className="flex flex-col gap-3">
        {entitiesOnCvlFlow.map(investmentEntity => (
          <AccreditationResumeCard
            key={investmentEntity.id}
            investmentEntityId={investmentEntity.id}
            entityName={investmentEntity.name}
          />
        ))}
      </div>
    </section>
  );
};

export default AccreditationResumeSection;
